import { emptyView } from "#/assets/cart";
import { auth } from "#/utils";
import { Icon } from "@monta/design-system";
import { useMontaNavigate } from "@monta/router-react";
import type { TUser } from "@monta/utils";
import styles from "./emptyView.module.scss";

interface LoginInfo {
  loginInfo: TUser | undefined;
}

const EmptyView = (props: LoginInfo) => {
  const { loginInfo } = props;
  const navigate = useMontaNavigate();

  return (
    <div className={styles["main-container"]}>
      <div className={styles["container"]}>
        <div className={styles["cart-Picture"]}>
          <img src={emptyView} alt="empty-cart" />
        </div>
        <div className={styles["cart-title"]}>سبد خرید شما خالی است!</div>
        <button
          onClick={() => {
            if (loginInfo) auth.redirectToDefault();
            else navigate("/", { baseUrl: "LANDING_URL" });
          }}
          className={styles["cart-button"]}
        >
          <span>بازگشت به صفحه محصولات</span>
          <Icon icon={"mi-Arrow-Left"} size={1} />
        </button>
      </div>
    </div>
  );
};

export default EmptyView;
